module.exports = __webpack_public_path__ + "img/tuxsuite-build.7f2fb253.svg";